'use strict';

// Import Libraries
import React from 'react';
// Import JS Modules
import Currency     from '../_utils/tools/currency';
import DisplayPrice from '../_utils/display-price';

const Price = ({now, was, includeFrom, displayWas, showUnitPriceOnItemPages}) => {
  return (
    <div>
      <DisplayPrice price={now}
                    includeFrom={includeFrom} />
      {showUnitPriceOnItemPages && <span className="from"> each</span>}
      {renderWasPriceSection()}
    </div>
  );

  function renderWasPriceSection() {
    if (displayWas && was) {
      return (
        <span className='was-price'>
          {Currency.format(was)}
        </span>
      );
    }
  }
};

export default Price;
